import React from 'react';
import PropTypes from 'prop-types';
import translator from '../../translations/drupalTranslator';
import {supportedProductCodes} from '../../constants/supportedProductCodes';
import Translate from '../Translate';

export const ProductBylineComponent = ({rental}) => {
	const productCode = rental.information.productCode;

	if (!supportedProductCodes.find(x => x.productCode === productCode)) {
		return (null);
	}

	/* Relative path to product icon */
	const getProductByline = (productCode) => {
		const product = supportedProductCodes.find(x => x.productCode === productCode)

		switch(productCode) {
			case 'LAND':
				return  <Translate
					args={{'!productIcon': `<img src=${product.iconUrl}></img>`}}
					content="A !productIcon holiday park home"
				/>
		}
  };

	return getProductByline(productCode)
};

ProductBylineComponent.propTypes = {
  byline: PropTypes.string
};

export default ProductBylineComponent;
